<template src="./template.html" ></template>

<script>
import _ from 'lodash'
import vueAxios from '../../functions/vueAxios'
import myDate from '../../functions/myDate'
import Utils from '../../functions/utils'
import MyRpTable from './table.vue'
import MyButtons from '../add/Buttons.vue'
import MyAlert from '../../components/alert/MyAlert.vue'
import MyPersons from '../../components/MyPersons.vue'
import MyCosts from '../../components/MyCosts.vue'
import MyIncomes from '../../components/MyIncomes.vue'
import MyAbouts from '../../components/MyAboutsRP.vue'
import MyComment from '../../components/MyComment.vue'
import MyBalances from '../../components/MyBalances.vue'

export default {
  name: 'RpItems',
  props: ['formTitle'],
  methods: {
    handleBeforeUnload(event) {
      if (this.isDirty) {
        event.preventDefault()
        event.returnValue = ''
      }
    },
    async onSave(e) {
      this.$refs.form.validate()
      if (!this.valid || this.submitStatus === 'PENDING') return

      if (!this.model.type && this.route) {
        this.model.type = this.route.slice(0, -1)
      }

      const method = this.formState === 'edit' ? 'PUT' : 'POST'
      const payload = {
        method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        }
      }
      if (!e.esc) {
        if (!window.confirm('آیا مایل به ذخیره سند هستید؟')) return
      }

      try {
        this.submitStatus = 'PENDING'
        await this.$store.dispatch('save', payload)
        const res = this.$store.getters.saveData
        if (res?.insert || res?.update) {
          if (res._id) this.idForTg = res._id
          this.alert = true
          //
          this.originalModel = _.cloneDeep(this.model)
          this.isDirty = false
        } else {
          this.submitStatus = null
        }
      } catch (e) {
        console.error(e)
        this.submitStatus = null
      }
    },
    async setBalance() {
      if (!this.model.person_id) return
      try {
        const res = await this.personBalance(this.model.person_id, 'balance')
        this.balance.current = res.balance
        this.calcNewBalance(this._rpPrice)
      } catch (e) {
        console.error(e)
      }
    },
    async calcNewBalance(rpPrice) {
      const isAdd = this.formState === 'add'
      const samePerson = this.model.person_id === this.prevPerson_id
      const curr = this.balance.current
      const prev = this.prevBalance
      let newBalance = curr

      if (this.route === 'receipts') {
        newBalance = isAdd ? curr - rpPrice :
          samePerson ? curr + prev - rpPrice : curr - rpPrice
      } else if (this.route === 'payments') {
        newBalance = isAdd ? curr + rpPrice :
          samePerson ? curr - prev + rpPrice : curr + rpPrice
      }
      this.balance.new = newBalance
    },
    changeOwnerType(value) {
      switch (value) {
        case 'person':
          delete this.model.cost_id
          delete this.model.income_id
          break
        case 'cost':
          delete this.model.person_id
          delete this.model.income_id
          break
        case 'income':
          delete this.model.person_id
          delete this.model.cost_id
          break
      }
    },
    addRpRow(item) {
      let i = this.model.items.slice();
      let type = item.type || 'bankReceipt'
      let newItem = {};
      if (type === 'pos' || type === 'bankReceipt') {
        newItem = this.newBankReceiptModel(type)
        if (type === 'bankReceipt' && this.route === 'payments') {
          newItem.fee = 0
        }
      } else if (type === 'cheque') {
        newItem = this.newChequeModel()
      } else if (type === 'cash') {
        newItem = this.newCashModel()
      }
      i.splice(i.indexOf(item) + 1, 0, newItem)
      this.model.items = i
    },
    editRpRow(type, i) {
      let s = this.model.items.slice();
      let newItem = {};
      if (type === 'pos' || type === 'bankReceipt') {
        newItem = this.newBankReceiptModel(type)
        if (type === 'bankReceipt' && this.route === 'payments') {
          newItem.fee = 0
        }
      } else if (type === 'cheque') {
        newItem = this.newChequeModel()
      } else if (type === 'cash') {
        newItem = this.newCashModel()
      }
      s[i] = newItem
      this.model.items = s
    },
    removeRpRow(item) {
      let i = this.model.items.slice();
      i.splice(i.indexOf(item), 1);
      this.model.items = i
    },
    newBankReceiptModel(_type) {
      return {
        type: _type,
        bank_account_id: null,
        serial: null,
        // date: '',
        date: myDate.toJalaali(new Date()).date,
        price: null,
        comment: null,
        checkBill: '-',
        checkHB: '-',
        checkDoc: '-'
      }
    },
    newChequeModel() {
      return {
        type: 'cheque',
        bank_id: null,
        serial: null,
        date: myDate.toJalaali(new Date()).date,
        number: null,
        branch: null,
        price: null,
        comment: null
      }
    },
    newCashModel() {
      return {
        type: 'cash',
        box_id: null,
        price: null,
        comment: null
      }
    },
    async checkItem(i, url, targetField) {
      const item = this.model.items[i];
      if (!item || !['pos', 'bankReceipt'].includes(item.type)) return;

      const hasRequiredFields = (
        ['receipts', 'payments'].includes(this.route) &&
        item.bank_account_id &&
        item.serial &&
        item.date &&
        item.price
      );

      if (!hasRequiredFields) {
        item[targetField] = '-';
        return;
      }

      try {
        const price = this.route === 'payments' ? -Math.abs(item.price) : item.price;

        const res = await vueAxios.get(url, {
          params: {
            bank_account_id: item.bank_account_id,
            serial: item.serial,
            date: item.date,
            price: price
          }
        })
        item[targetField] = res?.[0]?.count || 0;
      } catch (err) {
        console.error(`${targetField} error:`, err);
        item[targetField] = 0;
      }
    },
    async checkBill(i) {
      return this.checkItem(i, '/bank_bill/rpControl', 'checkBill');
    },
    async checkHB(i) {
      return this.checkItem(i, '/bank_accounts/rpControl', 'checkHB');
    },
    checkDoc() {
      try {
        //ساخت کلید منحصربه‌فرد برای هر ردیف
        const keyOf = (item) =>
          `${item.type}-${item.bank_account_id}-${item.serial}-${item.date}-${item.price}`;

        // مرحله ۲: ساخت نقشه از کلید → ایندکس‌ها
        const map = {};
        this.model.items.forEach((item, index) => {
          if (['pos', 'bankReceipt'].includes(item.type) &&
            item.bank_account_id && item.serial && item.date && item.price) {
            const key = keyOf(item);
            if (!map[key]) map[key] = [];
            map[key].push(index);
          }
        });

        // مرحله ۳: ایندکس‌های تکراری را پیدا کن
        const duplicates = new Set(
          Object.values(map)
          .filter(indexes => indexes.length > 1) // فقط کلیدهای تکراری
          .flat() // همه ایندکس‌ها در یک آرایه
        );

        // مرحله ۴: مقدار checkDoc برای همه ردیف‌ها مشخص شود
        this.model.items.forEach((item, index) => {
          item.checkDoc = duplicates.has(index) ? 1 : 0;
        });

      } catch (err) {
        console.error('checkDoc error:', err);
      }
    }
  },
  components: {
    MyAlert,
    MyButtons,
    MyPersons,
    MyCosts,
    MyIncomes,
    MyAbouts,
    MyComment,
    MyBalances,
    MyRpTable,
  },
  data() {
    return {
      submitStatus: null,
      valid: false,
      alert: false,
      idForTg: '',
      prevPerson_id: null,
      prevInvoiceType: null,
      prevBalance: 0,
      model: {
        type: null,
        ownerType: 'person',
        items: [],
      },
      balance: {
        current: 0,
        new: 0,
      },
      originalModel: null,
      isDirty: false,
      stabilizeTimer: null, // ← برای پایش پایداری
    }
  },
  computed: {
    clonedItems() {
      return JSON.parse(JSON.stringify(this.model))
    },
    _rpTotal() {
      return this.model.items.reduce((total, item) => {
        if (!item.discount && item.price) {
          return total + Number(Utils.rmCamma(item.price));
        }
        return total;
      }, 0);
    },
    _rpPrice() {
      const discountItem = this.model.items.find(x => x.discount);
      if (!discountItem?.discount) return 0;

      const discount = Number(Utils.rmCamma(discountItem.price));
      const rpTotal = this._rpTotal;
      const isCostId = discountItem.discount.label === 'cost_id';
      const isReceipts = this.route === 'receipts';

      // اگر isReceipts و isCostId برابر باشند، علامت مثبت، در غیر این‌صورت منفی
      const sign = (isReceipts === isCostId) ? 1 : -1;
      return rpTotal + sign * discount;
    },
  },
  watch: {
    model: {
      deep: true,
      handler(newVal) {
        // اگر originalModel هنوز ست نشده یعنی در حال پایدارسازی هستیم
        if (!this.originalModel) {
          clearTimeout(this.stabilizeTimer)
          this.stabilizeTimer = setTimeout(() => {
            this.originalModel = _.cloneDeep(this.model)
            this.isDirty = false
          }, 300) // ← اگر 300ms تغییر نداشت یعنی فرم پایدار شده
        } else {
          // بعد از ست‌شدن originalModel تغییرات واقعی کاربر بررسی شود
          this.isDirty = !_.isEqual(newVal, this.originalModel)
        }
      }
    },
    'model.person_id'(newVal) {
      if (!newVal) {
        this.balance = {
          current: 0,
          new: 0
        }
      }
    },
    _rpPrice(newVal) {
      this.calcNewBalance(newVal)
    },
  },
  async created() {
    this.formState = this.$router.currentRoute.path.split('/')[2]
    this.route = this.$store.getters.pageInfo.route

    if (this.formState === 'edit') {
      const mid = this.$router.currentRoute.path.split('/')[3]
      const data = {
        url: `/api/${this.route}`,
        params: {
          mid
        }
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      this.prevPerson_id = this.model.person_id
      this.prevBalance = this._rpPrice
      await this.setBalance()
    } else {
      this.addRpRow(this.model)
      this.model.items.push({
        discount: 1,
        price: 0
      })
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    clearTimeout(this.stabilizeTimer)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
}
</script>
